"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var InputWithOptions_st_css_1 = require("./InputWithOptions.st.css");
var dropdown_1 = require("../dropdown");
var dropdown_option_1 = require("../dropdown-option");
var input_1 = require("../input");
var filter_data_props_1 = require("../../utils/filter-data-props");
exports.DataHooks = {
    input: 'input',
    emptyState: 'input-with-options-empty-state',
};
/**
 * InputWithOptions
 */
var InputWithOptions = /** @class */ (function (_super) {
    tslib_1.__extends(InputWithOptions, _super);
    function InputWithOptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dropDownRef = null;
        _this.isEditing = false;
        _this.state = {
            ariaActivedescendant: null,
            ariaExpanded: false,
        };
        _this._setDropDownRef = function (ref) {
            _this.dropDownRef = ref;
        };
        _this.changeExpanded = function (isExpanded) {
            _this.setState({ ariaExpanded: isExpanded });
        };
        _this.onOptionHover = function (option) {
            var ariaActivedescendant = option ? option._DOMid : null;
            _this.setState({ ariaActivedescendant: ariaActivedescendant });
        };
        _this._onSelect = function (option) {
            _this.isEditing = false;
            var _a = _this.props, onSelect = _a.onSelect, onManualInput = _a.onManualInput, inputProps = _a.inputProps;
            if (option) {
                onSelect(option);
            }
            else {
                onManualInput(inputProps.value);
            }
            _this.setState({ ariaActivedescendant: null });
        };
        _this._onKeyDown = function (event) {
            if (!event.key.startsWith('Arrow')) {
                _this.isEditing = true;
                _this.setState({ ariaActivedescendant: null });
            }
            var onKeyDown = _this.props.inputProps.onKeyDown;
            onKeyDown && onKeyDown(event);
        };
        _this._onFocus = function (event) {
            _this.isEditing = false;
            var onFocus = _this.props.inputProps.onFocus;
            onFocus && onFocus(event);
        };
        _this._onBlur = function (event) {
            if (_this.isEditing) {
                _this._onSelect(null);
            }
            var onBlur = _this.props.inputProps.onBlur;
            onBlur && onBlur(event);
        };
        _this._onContentMouseDown = function (e) {
            var onContentMouseDown = _this.props.onContentMouseDown;
            _this.isEditing = false;
            onContentMouseDown && onContentMouseDown(e);
        };
        return _this;
    }
    InputWithOptions.prototype.open = function () {
        // Using getInstance() is here because closeOutside HOC
        this.dropDownRef && this.dropDownRef.open();
    };
    InputWithOptions.prototype.close = function () {
        this.dropDownRef && this.dropDownRef.close();
    };
    InputWithOptions.prototype._filterOptions = function () {
        var _a = this.props, highlightMatches = _a.highlightMatches, inputProps = _a.inputProps, options = _a.options, filterPredicate = _a.filterPredicate, emptyStateMessage = _a.emptyStateMessage, emptyStateStyle = _a.emptyStateStyle;
        if (!inputProps.value || !this.isEditing) {
            return options;
        }
        var filteredOptions = options.filter(function (option) {
            return (!option.isSelectable && option.value) ||
                (option.isSelectable &&
                    option.value &&
                    filterPredicate(inputProps.value, option.value));
        });
        if (!highlightMatches) {
            return filteredOptions;
        }
        if (emptyStateMessage && filteredOptions.length === 0) {
            return [
                dropdown_option_1.OptionFactory.create({
                    render: function () { return (React.createElement("div", { "data-hook": exports.DataHooks.emptyState, style: emptyStateStyle || {} }, emptyStateMessage)); },
                    isDisabled: true,
                }),
            ];
        }
        return filteredOptions.map(function (option) {
            return option.isSelectable && option.value
                ? dropdown_option_1.OptionFactory.createHighlighted(option, inputProps.value)
                : option;
        });
    };
    InputWithOptions.prototype.render = function () {
        var _a = this.props, placement = _a.placement, openTrigger = _a.openTrigger, initialSelectedIds = _a.initialSelectedIds, onInitialSelectedOptionsSet = _a.onInitialSelectedOptionsSet, multi = _a.multi, fixedFooter = _a.fixedFooter, fixedHeader = _a.fixedHeader, timeout = _a.timeout, onDeselect = _a.onDeselect, inputProps = _a.inputProps, forceContentElementVisibility = _a.forceContentElementVisibility, inlineStyles = _a.style, id = _a.id, allowReselect = _a.allowReselect, flip = _a.flip, fixed = _a.fixed, moveBy = _a.moveBy, optionsContainerZIndex = _a.optionsContainerZIndex, className = _a.className;
        var contentId = id ? id + "-content" : null;
        return (React.createElement(dropdown_1.Dropdown, tslib_1.__assign({ className: InputWithOptions_st_css_1.st(InputWithOptions_st_css_1.classes.root, className), placement: placement, openTrigger: openTrigger, disabled: inputProps.disabled, onSelect: this._onSelect, onOptionHover: this.onOptionHover, fixedFooter: fixedFooter, fixedHeader: fixedHeader, onDeselect: onDeselect, initialSelectedIds: initialSelectedIds, onInitialSelectedOptionsSet: onInitialSelectedOptionsSet, options: this._filterOptions(), timeout: timeout, multi: multi, forceContentElementVisibility: forceContentElementVisibility, style: inlineStyles, id: id, ref: this._setDropDownRef, allowReselect: allowReselect, flip: flip, fixed: fixed, moveBy: moveBy, onContentMouseDown: this._onContentMouseDown, contentId: contentId, onExpandedChange: this.changeExpanded, optionsContainerZIndex: optionsContainerZIndex }, filter_data_props_1.filterDataProps(this.props)),
            React.createElement(input_1.Input, tslib_1.__assign({ "data-hook": exports.DataHooks.input }, inputProps, { role: "combobox", "aria-autocomplete": "both", "aria-owns": contentId, "aria-expanded": this.state.ariaExpanded, "aria-activedescendant": this.state.ariaActivedescendant, onKeyDown: this._onKeyDown, onFocus: this._onFocus, onBlur: this._onBlur, className: InputWithOptions_st_css_1.classes.inputComponent }))));
    };
    InputWithOptions.displayName = 'InputWithOptions';
    InputWithOptions.defaultProps = {
        openTrigger: 'click',
        placement: 'bottom-start',
        multi: false,
        initialSelectedIds: [],
        highlightMatches: true,
        onSelect: function () { return null; },
        onDeselect: function () { return null; },
        onManualInput: function () { return null; },
        onInitialSelectedOptionsSet: function () { return null; },
        filterPredicate: function (inputValue, optionValue) {
            return optionValue.toLowerCase().includes(inputValue.toLowerCase());
        },
    };
    return InputWithOptions;
}(React.PureComponent));
exports.InputWithOptions = InputWithOptions;
//# sourceMappingURL=InputWithOptions.js.map